import $ from 'jquery';
import Numbered from 'input.numbered';
import Animation from 'modules/animation/animation';
import 'jquery.inputmask/dist/jquery.inputmask.bundle';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaPayment',
			recaptchaKey: yotaPortlets.recaptchaKey,
			recaptchaPrefix: yotaPortlets.recaptchaPrefix,
			dom: {
				form: '#yotaPaymentForm',
				radioPhone: '#yotaPaymentRadioPhone',
				radioModem: '#yotaPaymentRadioModem',
				amount: '#yotaPaymentAmount',
				phone: '#yotaPaymentPhone',
				modem: '#yotaPaymentModem',
				efc: '#yotaPaymentEfc',
				way: '#inplatFrameContainer',
				title: '#yotaPaymentTitle',
				amountAttr: '.js-payment-attr-amount',
				recaptcha: '.js-recaptcha',
				tryAgainAfterExceed: '.js-try-again-after-exceed'
			},
			classes: {
				error: 'b-payment__field_state_error',
				modem: 'b-payment_state_modem',
				blocked: 'b-payment_state_blocked',
				paymentUnavailable: 'b-payment_state_unavailable',
				requestCountExceed: 'b-payment_state_request_count_exceed',
				incorrectAccount: 'b-payment_state_incorrect_account',
				recaptchaOk: 'b-payment_state_recaptcha_ok',
				way: 'b-payment_state_way',
				load: 'b-payment_state_load',
				efcTypePhone: 'efc-type-phone',
				field: {
					state: {
						disabled: 'b-field_state_disabled',
						error: 'b-field_state_error'
					}
				}
			}
		};

		this.errorCodes = {
			INCORRECT_ACCOUNT: 'INCORRECT_ACCOUNT',
			REQUEST_COUNT_EXCEED: 'REQUEST_COUNT_EXCEED',
			PAYMENT_IS_TEMPORARILY_UNAVAILABLE: 'PAYMENT_IS_TEMPORARILY_UNAVAILABLE'
		};

		this.patternMail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		this.patternPhone = /^((79)|(89)|(9))\d{9}$/;

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.isPhone = true;
		this.sended = false;
		this.init = false;
		return this;
	}

	getDom() {
		this.$form = $(this.options.dom.form);
		this.$radioPhone = $(this.options.dom.radioPhone);
		this.$radioModem = $(this.options.dom.radioModem);
		this.$radio = this.$radioPhone.add(this.$radioModem);
		this.$amount = $(this.options.dom.amount);
		this.$phone = $(this.options.dom.phone);
		this.$modem = $(this.options.dom.modem);
		this.$efc = $(this.options.dom.efc);
		this.$way = $(this.options.dom.way);
		this.way = this.$way[0];
		this.$title = $(this.options.dom.title);
		this.$amountAttr = $(this.options.dom.amountAttr);
		this.$recaptcha = $(this.options.dom.recaptcha);
		this.$tryAgainAfterExceed = $(this.options.dom.tryAgainAfterExceed);
		this.$window = $(window);
		return this;
	}

	onChangeType(event) {
		if (this.$el.hasClass(this.options.classes.blocked) ||
			this.$el.hasClass(this.options.classes.way) ||
			this.$el.hasClass(this.options.classes.load)
		) {
			this.$radioPhone.prop('checked', this.isPhone);
			this.$radioModem.prop('checked', !this.isPhone);
			event.preventDefault();
			return false;
		}
		this.isPhone = this.$radioPhone.prop('checked');
		this.$el.toggleClass(this.options.classes.modem, !this.isPhone);

		this.$amount
			.parent()
			.removeClass(this.options.classes.field.state.error)
			.parent()
			.removeClass(this.options.classes.error);
		this.$phone.parent().removeClass(this.options.classes.field.state.error);
		this.$modem.parent().removeClass(this.options.classes.field.state.error);

		this.animation.amount.stop('shake');
		this.animation.modem.stop('shake');
		this.animation.phone.stop('shake');
	}


	declOfNum(number, titles) {
		const cases = [2, 0, 1, 1, 1, 2];
		return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
	}

	onInputAmount(event) {
		const value = this.$amount.val();
		if (value !== '') {
			let amount = value.replace(/[^\d]/ig, '').replace(/^0/ig, '');
			this.$amountAttr.attr('data-after', this.declOfNum(amount, ['рубль', 'рубля', 'рублей']));
			if (amount > this.amount.max) {
				amount = this.amount.max;
			}
			if (amount < this.amount.min) {
				amount = this.amount.min;
			}
			amount = String(amount).split( /(?=(?:\d{3})+(?!\d))/ ).join(' ');
			if (amount != value) {
				event.currentTarget.value = amount;
			}
		} else {
			this.$amountAttr.attr('data-after', 'рублей');
		}
		return this;
	}

	onInputEfc(event) {
		const value = this.$efc.val();
		if (value !== '') {
			let efc = $(event.currentTarget).hasClass(this.options.classes.efcTypePhone) ? value.replace(/[^\dA-Z-_.@+()]/gi, '') : value.replace(/[^\dA-Z-_.@]/gi, '');
			if (efc != value) {
				event.currentTarget.value = efc;
			}

			if (event.type === 'blur') {
				if (this.patternPhone.test(efc.replace(/[\s-()+]/gi, '')) || this.patternPhone.test(efc)) {
					this.setEfcMask();
				}
			}
		}
		return this;
	}

	validate() {
		const self = this;
		const phone = self.phone.validate();
		const modem = self.modem.validate();
		const amount = self.$amount.val();
		const efc = self.$efc.val();
		let error = false;

		if (amount == '') {
			error = true;
			self.$amount
				.prop('disabled', false)
				.parent()
				.addClass(self.options.classes.field.state.error)
				.removeClass(self.options.classes.field.state.disabled)
				.parent()
				.addClass(self.options.classes.error);
			self.animation.amount.play('shake');
		} else {
			self.animation.amount.stop('shake');
		}

		if (efc == '' || (!this.patternMail.test(efc) && !this.patternPhone.test(efc) && !this.patternPhone.test(efc.replace(/[\s-+()]/gi, '')))) {
			error = true;
			self.$efc
				.prop('disabled', false)
				.parent()
				.addClass(self.options.classes.field.state.error)
				.removeClass(self.options.classes.field.state.disabled)
				.parent()
				.addClass(self.options.classes.error);
			self.animation.efc.play('shake');
		} else {
			self.animation.efc.stop('shake');
			if (this.patternPhone.test(efc.replace(/[\s-()+]/gi, '')) || this.patternPhone.test(efc)) {
				this.setEfcMask();
			}
		}

		if (phone <= '' && self.isPhone) {
			error = true;
			self.$phone
				.prop('disabled', false)
				.parent()
				.addClass(self.options.classes.field.state.error)
				.removeClass(self.options.classes.field.state.disabled);
			self.animation.phone.play('shake');
		} else {
			self.animation.phone.stop('shake');
		}

		if (modem <= '' && !self.isPhone) {
			error = true;
			self.$modem
				.prop('disabled', false)
				.parent()
				.addClass(self.options.classes.field.state.error)
				.removeClass(self.options.classes.field.state.disabled);
			self.animation.modem.play('shake');
		} else {
			self.animation.modem.stop('shake');
		}

		return !error;
	}
	setEfcMask() {
		this.$efc.addClass(this.options.classes.efcTypePhone);
		let efc = this.$efc.val().replace(/[-()]/gi, '');
		if (efc.length === 11) {
			this.$efc.val(efc.slice(1));
		} else {
			this.$efc.val(efc);
		}
		this.$efc.inputmask('+7 (999) 999-99-99');
	}

	removeEfcMask() {
		this.$efc.inputmask('remove');
		this.$efc.removeClass(this.options.classes.efcTypePhone);
	}

	onEfcFocus(event) {
		const $filed = $(event.currentTarget);
		$filed
			.parent()
			.removeClass(this.options.classes.field.state.error)
			.parent()
			.removeClass(this.options.classes.error);
		if (this.$efc.inputmask) {
			this.removeEfcMask();
		}
	}

	onFocus(event) {
		const $filed = $(event.currentTarget);
		$filed
			.parent()
			.removeClass(this.options.classes.field.state.error)
			.parent()
			.removeClass(this.options.classes.error);
	}

	startWait() {
		const self = this;
		self.wait = setTimeout(function () {
			self.errorWay();
		}, 30000);
	}

	startWay(src) {
		this.$el
			.removeClass(this.options.classes.blocked)
			.addClass(this.options.classes.way);

		this.$title
			.data('normal', this.$title.text())
			.text(this.$title.data('way'));

		this.$amount
			.add(this.$phone)
			.add(this.$modem)
			.add(this.$efc)
			.prop('disabled', true)
			.parent()
			.addClass(this.options.classes.field.state.disabled);

		if (this.init) {
			this.startWait();
			/* eslint-disable new-cap */
			window.InplatPaymentOpenInFrame({
				link: src,
				target: this.way
			});
		}
	}

	errorWay() {
		this.$title.text(this.$title.data('normal'));
		this.startBlocked();
		this.$way.html('');
	}

	startBlocked(blockedCssClass) {
		const {paymentUnavailable, blocked} = this.options.classes;
		const blockedClassName = blockedCssClass || (paymentUnavailable + ' ' + blocked);

		this.$amount
			.add(this.$phone)
			.add(this.$modem)
			.add(this.$efc)
			.prop('disabled', true)
			.parent()
			.addClass(this.options.classes.field.state.disabled);
		this.$el
			.addClass(blockedClassName)
			.removeClass(this.options.classes.load)
			.removeClass(this.options.classes.way);
	}

	stopBlocked(blockedCssClass) {
		const {paymentUnavailable, blocked} = this.options.classes;
		const blockedClassName = ((blockedCssClass || paymentUnavailable) + ' ' + blocked);

		this.$amount
			.add(this.$phone)
			.add(this.$modem)
			.add(this.$efc)
			.prop('disabled', false)
			.parent()
			.removeClass(this.options.classes.field.state.disabled);
		this.$el
			.removeClass(blockedClassName)
			.removeClass(this.options.classes.recaptchaOk)
			.removeClass(this.options.classes.way);
	}

	startError(error) {

		this.$el
			.removeClass(this.options.classes.load)
			.removeClass(this.options.classes.way);

		if (!error.amount) {
			this.$amount.parent().addClass(this.options.classes.field.state.error);
			this.$amount.parent().parent().addClass(this.options.classes.error);
			this.animation.amount.play('shake');
		} else {
			this.animation.amount.stop('shake');
		}

		if (!error.phone) {
			this.$phone.parent().addClass(this.options.classes.field.state.error);
			this.animation.phone.play('shake');
		} else {
			this.animation.phone.stop('shake');
		}

		if (!error.modem) {
			this.$modem.parent().addClass(this.options.classes.field.state.error);
			this.animation.modem.play('shake');
		} else {
			this.animation.modem.stop('shake');
		}

		if (error.contactType === null) {
			this.$efc.parent().addClass(this.options.classes.field.state.error);
			this.animation.efc.play('shake');
		} else {
			this.animation.efc.stop('shake');
		}
	}

	onSubmit(event) {
		const self = this;
		event.preventDefault();
		if (self.$el.hasClass(self.options.classes.paymentUnavailable)) {
			self.stopBlocked(self.options.classes.paymentUnavailable);
		} else if (self.$el.hasClass(self.options.classes.requestCountExceed)) {
			self.stopBlocked(self.options.classes.requestCountExceed);
		} else if (self.$el.hasClass(self.options.classes.incorrectAccount)) {
			self.stopBlocked(self.options.classes.incorrectAccount);
		} else if (self.validate()) {
			if (!self.sended) {
				self.$el.addClass(self.options.classes.load);
				self.sended = true;
				$.ajax({
					url: self.$form.attr('action'),
					type: self.$form.attr('method'),
					data: self.$form.serialize(),
					dataType: 'json',
					success: function (json) {
						if (json) {
							if (json.location) {
								window.location.assign(json.location);
							} else {
								if (json.success && json.src) {
									self.startWay(json.src);
								}
								if (!json.success && !!json.fields) {
									self.startError(json.fields);
								}
								if (!json.success && json.errorCode === self.errorCodes.PAYMENT_IS_TEMPORARILY_UNAVAILABLE) {
									self.startBlocked(self.options.classes.paymentUnavailable);
								}
								if (!json.success && json.errorCode === self.errorCodes.REQUEST_COUNT_EXCEED) {
									grecaptcha.reset();
									self.startBlocked(self.options.classes.requestCountExceed);
								}
								if (!json.success && json.errorCode === self.errorCodes.INCORRECT_ACCOUNT) {
									self.startBlocked(self.options.classes.incorrectAccount);
								}
							}
						} else {
							alert(self.$form.data('error'));
						}
						self.sended = false;
					},
					error: function () {
						alert(self.$form.data('error'));
						self.$el.removeClass(self.options.classes.load);
						self.sended = false;
					}
				});
			}
		}
	}

	bindMessage() {
		const self = this;

		const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
		const eventer = window[eventMethod];
		const messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

		eventer(messageEvent, function (e) {
			const key = e.message ? 'message' : 'data';
			const data = e[key];
			self.frameMessage(data);
		}, false);
	}

	frameMessage(data) {
		if (data.setHeight) {
			this.way.style.height = data.setHeight;
		}
		if (data.setSrc) {
			this.startWay(data.setSrc);
		}
	}

	stopLoad() {
		const self = this;
		clearTimeout(self.wait);
		setTimeout(function () {
				self.$el.removeClass(self.options.classes.load);
		}, 500);
	}

	initInplatCallbacks() {
		const self = this;

		window.InplatPaymentCallbacks = function (params) {
			if (params.event === 'formIframeResized') {
				self.frameMessage({setHeight: params.custom + 'px'});
			}
			if (params.event === 'errorOpened') {
				self.errorWay();
				self.stopLoad();
			}
			if (params.event === 'yotaLoaded') {
				self.stopLoad();
			}
		};

		return self;
	}

	onLoadRecaptcha() {
		this.recaptcha = grecaptcha.render(this.$recaptcha[0], {
			sitekey: this.options.recaptchaKey,
			callback: this.onReceiveRecaptchaResponse.bind(this)
		});
	}

	onReceiveRecaptchaResponse(recaptchaResponse) {
		const validationUrl = this.$form.data('actionrecaptcha');

		$('#g-recaptcha-response').removeAttr('name');

		if (!recaptchaResponse || !validationUrl) {
			return;
		}

		$.ajax({
			url: validationUrl,
			type: this.$form.attr('method'),
			dataType: 'json',
			data: {
				[this.options.recaptchaPrefix + 'g-recaptcha-response']: recaptchaResponse,
				[this.options.recaptchaPrefix + 'cmd']: 'recaptcha',
				[this.options.recaptchaPrefix + 'type']: (this.isPhone) ? 'phone' : 'modem',
				[this.options.recaptchaPrefix + 'amount']: this.$amount.val(),
				[this.options.recaptchaPrefix + 'phone']: (this.isPhone) ? this.$phone.val() : '',
				[this.options.recaptchaPrefix + 'modem']: (!this.isPhone) ? this.$modem.val() : '',
				[this.options.recaptchaPrefix + 'efc']: this.$efc.val()
			}
		})
			.then(response => {
				if (response && response.success) {
					this.$el.addClass(this.options.classes.recaptchaOk);
					this.$tryAgainAfterExceed.removeAttr('disabled');
				} else if (response && response.errorCode === this.errorCodes.REQUEST_COUNT_EXCEED) {
					this.$el.addClass(this.options.classes.recaptchaOk);
					this.$tryAgainAfterExceed.removeAttr('disabled');
				} else if (response && response.errorCode === this.errorCodes.PAYMENT_IS_TEMPORARILY_UNAVAILABLE) {
					this.stopBlocked(this.options.classes.requestCountExceed);
					this.startBlocked(this.options.classes.paymentUnavailable);
				} else if (response && response.errorCode === this.errorCodes.INCORRECT_ACCOUNT) {
					this.stopBlocked(this.options.classes.requestCountExceed);
					this.startBlocked(this.options.classes.incorrectAccount);
				} else {
					alert(this.$form.data('error'));
				}
			});
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.amount = {
				min: this.$amount.data('min'),
				max: this.$amount.data('max')
			};
			window.onloadCardPaymentRecaptcha = this.onLoadRecaptcha.bind(this);
			this.animation = {
				amount: new Animation({el: this.$amount.parent().parent()}),
				phone: new Animation({el: this.$phone.parent().parent()}),
				modem: new Animation({el: this.$modem.parent().parent()}),
				efc: new Animation({el: this.$efc.parent().parent()})
			};
			this.phone = new Numbered(this.$phone, {mask: '+7 (###) ###-##-##'});
			this.modem = new Numbered(this.$modem, {mask: '##########'});
			this.$radio.on('change', this.onChangeType.bind(this)).trigger('change');
			this.$amount.on('input keyup paste change blur', this.onInputAmount.bind(this)).trigger('blur');
			this.$efc.on('input keyup paste change blur', this.onInputEfc.bind(this)).trigger('blur');
			this.$tryAgainAfterExceed.attr('disabled', true);
			this.$form.on('submit', this.onSubmit.bind(this));
			this.$phone
				.add(this.$modem)
				.add(this.$amount)
				.on('change input focusin', this.onFocus.bind(this));
			this.$efc
				.on('change input focusin', this.onEfcFocus.bind(this));

			this.$window.on('yota.payment.inplatInitiated', () => {
				this.init = true;
			});

			this.bindMessage();
			this.initInplatCallbacks();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/payment/payment.js